import { withRBAC } from "../rbac";
import { RFQCreate } from "./RFQCreate";
import { RFQEdit } from "./RFQEdit";
import { RFQList } from "./RFQList";
import { RFQShow } from "./RFQShow";

export const rfqs = {
    list: withRBAC(RFQList, "view_procurement"),
    show: withRBAC(RFQShow, "view_procurement"),
    create: withRBAC(RFQCreate, "manage_procurement"),
    edit: withRBAC(RFQEdit, "manage_procurement"),
    recordRepresentation: 'reference'
};
